import ExportRootPage from 'pages/export-page';
import { ExportEventsPage } from 'pages/export-page/export-events-page';
import { ExportPatientsPage } from 'pages/export-page/export-patients-page';
import { MainPage } from 'pages/main-page';
import { VersioningPage } from 'pages/versioning-page';
import { PushNotificationsPage } from 'pages/push-notifications-page';
import UsersRootPage from 'pages/users-pages';
import { UserRoles } from 'enums';
import {
  AUTH_ROUTE,
  EXPORT_EVENTS_ROUTE,
  EXPORT_PATIENTS_ROUTE,
  EXPORT_R00T_ROUTE,
  USERS_ROUTE,
  VERSIONING_ROUTE,
  PUSH_NOTIFICATIONS_ROUTE,
} from './paths';

export const routes = [
  {
    role: [UserRoles.USER],
    path: AUTH_ROUTE,
    Component: MainPage,
  },
  {
    role: [UserRoles.ADMIN, UserRoles.SUPPORT],
    path: USERS_ROUTE,
    Component: UsersRootPage,
  },
  {
    role: [UserRoles.ADMIN, UserRoles.SUPPORT],
    path: EXPORT_R00T_ROUTE,
    Component: ExportRootPage,
  },
  {
    role: [UserRoles.ADMIN, UserRoles.SUPPORT],
    path: EXPORT_PATIENTS_ROUTE,
    Component: ExportPatientsPage,
  },
  {
    role: [UserRoles.ADMIN, UserRoles.SUPPORT],
    path: EXPORT_EVENTS_ROUTE,
    Component: ExportEventsPage,
  },
  {
    role: [UserRoles.ADMIN, UserRoles.SUPPORT],
    path: VERSIONING_ROUTE,
    Component: VersioningPage,
  },
  {
    role: [UserRoles.ADMIN, UserRoles.SUPPORT],
    path: PUSH_NOTIFICATIONS_ROUTE,
    Component: PushNotificationsPage,
  },
];
